// Best-effort Mac detection so keyboard-shortcut hints don't lie to Windows/Linux users.
// `navigator.userAgentData` (Client Hints) isn't universally supported yet, so fall back to
// the older `platform`/`userAgent` strings, which are still populated everywhere that matters.
const isMacPlatform = (): boolean => {
  if (typeof navigator === 'undefined') return true
  const platform = navigator.platform || navigator.userAgent || ''
  return /Mac|iPod|iPhone|iPad/.test(platform)
}

/** '⌘' on macOS/iOS, 'Ctrl' everywhere else — pairs with 'K' to label the search shortcut. */
export const getShortcutModifierLabel = (): string => (isMacPlatform() ? '⌘' : 'Ctrl')
